import { render, staticRenderFns } from "./End.vue?vue&type=template&id=6d06e06b&"
import script from "./End.vue?vue&type=script&lang=js&"
export * from "./End.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports